import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode, Thumbs, Pagination, Autoplay } from 'swiper';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import EFVideo from '@/components/UI/EFVideo';
import SVGPlay from '@/components/UI/svg/corporatesocialresponsibility/SVGPlay';
import { useGlobal } from '@/utils/useGlobal';

export default function More({ arr, onClose }: any) {
    const { useEffect, useState } = useGlobal();
    const [overH, setOverH] = useState(false);
    const [video, setVideo] = useState([]);
    const [videoShow, setVideoShow] = useState(false);
    const handlePlay = (cls: string) => {
        const target = document.querySelector(`.more ${cls}`) as HTMLVideoElement;
        target.play();
        const icon = document.querySelector('.more .play-icon') as HTMLElement;
        icon.classList.add('hide');
    };
    const handleEnd = (cls: string) => {
        const target = document.querySelector(`.more ${cls}`) as HTMLVideoElement;
        target.pause();
        target.currentTime = 0;
        const icon = document.querySelector('.more .play-icon') as HTMLElement;
        icon.classList.remove('hide');
    };
    const handlePlayWithImg = (sources: string[]) => {
        setVideo(sources);
        setVideoShow(true);
    };
    const handleEndWithImg = () => {
        setVideo([]);
        setVideoShow(false);
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const target = document.querySelector('.more .modal-content') as HTMLVideoElement;
            setOverH(target.offsetHeight >= window?.innerHeight - 120);
        }
    }, []);

    return (
        <div className={`more ${css['more']}`}>
            <div className="modal-content">
                <div className="close" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16ZM1.8 16C1.8 8.15756 8.15756 1.8 16 1.8C23.8424 1.8 30.2 8.15756 30.2 16C30.2 23.8424 23.8424 30.2 16 30.2C8.15756 30.2 1.8 23.8424 1.8 16Z"
                            fill="black"
                        />
                        <path
                            d="M10.3767 20.271C9.8849 20.7217 9.87466 21.1828 10.3459 21.6541C10.8172 22.1253 11.2783 22.1151 11.729 21.6233L16 17.4138L20.271 21.6233C20.7217 22.1151 21.1828 22.1253 21.6541 21.6541C22.1253 21.1828 22.1151 20.7217 21.6233 20.271L17.4138 16L21.6233 11.729C22.1151 11.2783 22.1253 10.8172 21.6541 10.3459C21.1828 9.87466 20.7217 9.88491 20.271 10.3767L16 14.5862L11.729 10.3767C11.2783 9.88491 10.8172 9.87466 10.3459 10.3459C9.87466 10.8172 9.8849 11.2783 10.3767 11.729L14.5862 16L10.3767 20.271Z"
                            fill="black"
                        />
                    </svg>
                </div>
                <div className={`modal-inner ${overH ? 'over' : ''}`}>
                    <div className="lists">
                        {arr?.map((list: any, m: number) => (
                            <div className="list" key={`list_${m}`}>
                                {list?.imgs?.length > 0 && (
                                    <div className="swiper-imgs">
                                        <Swiper
                                            className={`swiper-box ${list?.imgs?.length === 1 ? 'single' : ''}`}
                                            loop={list?.imgs?.length > 1}
                                            navigation={true}
                                            pagination={{ clickable: true }}
                                            slidesPerView={'auto'}
                                            lazy={true}
                                            autoplay={{
                                                delay: 4000,
                                                disableOnInteraction: false,
                                            }}
                                            spaceBetween={0}
                                            centeredSlides={true}
                                            speed={800}
                                            effect="flip"
                                            modules={[FreeMode, Navigation, Thumbs, Pagination, Autoplay]}
                                        >
                                            {list?.imgs.map((item: string, k: number) => (
                                                <SwiperSlide key={k}>
                                                    {Array.isArray(item) && (String(item[0])?.endsWith('.mp4') || String(item[0])?.endsWith('.webm')) ? (
                                                        <div className="video-box" onClick={() => handlePlay(`.video-${k}`)}>
                                                            <EFVideo
                                                                className={`fullImgs video-${k}`}
                                                                sources={item}
                                                                width="100%"
                                                                height="100%"
                                                                autoPlay={false}
                                                                muted={false}
                                                                loop={false}
                                                                aria-label={list?.title}
                                                                onEnded={() => handleEnd(`.video-${k}`)}
                                                            />
                                                            <SVGPlay className="play-icon" />
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <NextImage
                                                                className="fullImgs"
                                                                webpSrc={item[0]}
                                                                src={item[1] || item[0]}
                                                                alt={list?.title}
                                                                aria-label={list?.title}
                                                            />
                                                            {list?.isVideo && <SVGPlay className="play-icon" onClick={() => handlePlayWithImg(list?.video)} />}
                                                        </>
                                                    )}
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>
                                )}
                                <div className="modal-text">
                                    <p className="modal-title">{list?.title}</p>
                                    <p className="modal-desc">{list?.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {videoShow && (
                    <div className="big-video-wrapper">
                        <div className="big-video">
                            <EFVideo
                                className="fullImgs"
                                sources={video}
                                width="100%"
                                height="100%"
                                autoPlay={true}
                                muted={false}
                                loop={false}
                                aria-label={'video'}
                                onEnded={handleEndWithImg}
                                // @ts-ignore
                                controls
                            />
                            <span className="play-close" onClick={handleEndWithImg}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                    <path
                                        d="M18 0C27.9411 0 36 8.05887 36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0Z"
                                        fill="#9D9D9D"
                                    />
                                    <path
                                        d="M11.6738 22.8048C11.1205 23.312 11.109 23.8306 11.6392 24.3608C12.1694 24.891 12.688 24.8795 13.1952 24.3262L18 19.5906L22.8048 24.3262C23.312 24.8795 23.8306 24.891 24.3608 24.3608C24.891 23.8306 24.8795 23.312 24.3262 22.8048L19.5906 18L24.3262 13.1952C24.8795 12.688 24.891 12.1694 24.3608 11.6392C23.8306 11.109 23.312 11.1205 22.8048 11.6738L18 16.4094L13.1952 11.6738C12.688 11.1205 12.1694 11.109 11.6392 11.6392C11.109 12.1694 11.1205 12.688 11.6738 13.1952L16.4094 18L11.6738 22.8048Z"
                                        fill="white"
                                    />
                                </svg>
                            </span>
                        </div>
                    </div>
                )}
            </div>
            <style global jsx>
                {`
                    .ecoflow-pc {
                        height: 100vh !important;
                        overflow: hidden !important;
                    }
                    #allContentContainer {
                        z-index: 1111;
                    }
                `}
            </style>
        </div>
    );
}
